<template>
    <modal :show.sync="show" modalClasses="medium-sized-modal event-modal" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Schedule Meeting</h3>
        <b-form ref="AddMeetingForm" role="form" @submit.prevent="submit()">
            <b-row>
                <!-- FIELD LEADS -->
                <b-col cols="12">
                    <b-form-group label="Lead">
                        <el-select v-model="new_meeting.lead_id" filterable placeholder="Select">
                            <el-option
                            v-for="lead in leadName"
                            :key="lead.lead_id"
                            :label="lead.name"
                            :value="lead.lead_id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>

                <!-- FIELD TITLE -->
                <b-col cols="12">
                    <b-form-group label="Title">
                        <el-select v-model="new_meeting.title" filterable placeholder="Select">
                            <el-option
                            v-for="(title, index) in leadTitle"
                            :key="index"
                            :label="title.label"
                            :value="title.value">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>

                <!-- FIELD DATE START -->
                <b-col cols="12" md="6">
                    <b-form-group label="Date Start">
                        <b-form-datepicker :value="startValue" id="dateInput" readonly></b-form-datepicker>
                    </b-form-group>
                </b-col>

                <!-- FIELD DATE END -->
                <b-col cols="12" md="6">
                    <b-form-group label="Date End">
                        <b-form-datepicker v-model="endValue"></b-form-datepicker>
                    </b-form-group>
                </b-col>

                <!-- FIELD TIME START -->
                <b-col cols="12" md="6">
                    <b-form-group label="Time Start">
                        <el-time-picker
                            v-model="new_meeting.time_start"
                            placeholder="Time Start"
                            format="HH:mm A"
                            value-format="HH:mm:ss"
                            required
                            >
                        </el-time-picker>
                    </b-form-group>
                </b-col>
            
                <!-- FIELD TIME END -->
                <b-col cols="12" md="6">
                    <b-form-group label="Time End">
                        <el-time-picker
                            v-model="new_meeting.time_end"
                            placeholder="Time End"
                            format="HH:mm A"
                            value-format="HH:mm:ss"
                            required
                            >
                        </el-time-picker>

                    </b-form-group>
                </b-col>

                <!-- FIELD DESCRIPTION -->
                <b-col cols="12">
                    <b-form-group label="Description">
                        <b-form-input
                            v-model="new_meeting.description"
                            type="text"
                            required
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <!-- SUBMIT BUTTON -->
                <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                    <b-button type="submit" class="w-100" variant="primary">Schedule</b-button>
                </b-col>
            </b-row>
        </b-form>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option, TimePicker } from 'element-ui'
import {
    helperFunctionMixin,
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'
import { EventBus } from "@/main";

const today = new Date();
const y = today.getFullYear();
const m = today.getMonth();
const d = today.getDate();

export default {
    props: {
        create_meeting: Boolean,
        start: Date,
        end: Date,
        dateInfo: Object,
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
        [TimePicker.name]: TimePicker,
    },
    created(){
        this.fetchLead()
        // this.fetchHub()
    },
    computed: {
        show: {
            get() {
                return this.create_meeting;
            },
            set(newVal) {
                this.$emit('update:create_meeting', newVal);
            },
        },
        startValue: {
            get() {
                return this.new_meeting.start ? this.new_meeting.start.toISOString().slice(0, 16) : '';
            },
            set(value) {
                this.new_meeting.start = value ? new Date(value) : null;
            }
        },
        endValue: {
            get() {
                return this.new_meeting.end ? this.new_meeting.end.toISOString().slice(0, 16) : '';
            },
            set(value) {
                this.new_meeting.end = value ? new Date(value) : null;
            }
        },
    },
    watch: {
        start: {
            immediate: true,
            handler(newValue) {
                this.new_meeting.start = newValue;
                this.new_meeting.status = "Scheduled"
            }
        },
        end: {
            immediate: true,
            handler(newValue) {
                this.new_meeting.end = newValue;
            }
        },
        'new_meeting.isComplete'(value) {
            // Toggle the value of 'otherData' based on the checkbox state
            this.new_meeting.status = value ? 'Completed' : 'Scheduled';
        },
        'dateInfo.startStr'(newVal){
            var timeString = newVal.split("T")[1];
            this.new_meeting.time_start = timeString
        },
        'dateInfo.endStr'(newVal){
            var timeString = newVal.split("T")[1];
            this.new_meeting.time_end = timeString
        },
    },
    data() {
        return {
            new_meeting: {
                lead_id: '',
                hub_id: '',
                assigned_to: '',
                className: 'event-default',
                title: '',
                duration: '',
                description: '',
                type: '',
                location: '',
                start: '',
                end: '',
                time_start:'',
                time_end:'',
                date_end:'',
                isComplete:false,
                remark_meeting:'',
                status:'Scheduled'
            },
            leadTitle: [
                {
                value: 'D2W',
                label: 'D2W'
                }, 
                {
                    value: 'Personal Loan',
                    label: 'Personal Loan'
                }, 
                {
                value: 'Mortgage Service',
                label: 'Mortgage Service'
                }, 
                {
                value: 'Refinance',
                label: 'Refinance'
                }, 
                {
                value: 'Property',
                label: 'Property'
                },
                {
                value: 'SME Loan',
                label: 'SME Loan'
                },
                {
                value: 'Insurance',
                label: 'Insurance'
                },
                {
                value: 'Fintos Financing',
                label: 'Fintos Financing'
                },
                {
                value: 'Hire Purchase',
                label: 'Hire Purchase'
                }
            ],
            durationOptions: [{
                value: '30 mins',
                label: '30 mins'
                }, {
                value: '40 mins',
                label: '40 mins'
                }, {
                value: '60 mins',
                label: '60 mins'
                }, {
                value: '90 mins',
                label: '90 mins'
                }, {
                value: '120 mins',
                label: '120 mins'
            }],
            typeOptions: [
                { text: 'Offline', value: 'offline' },
                { text: 'Online', value: 'online' },
            ],
            // eventColors: [
			// 	"event-default",
			// 	"event-green",
			// 	"event-orange",
			// 	"event-red",
            // ],
            eventColors: [
          {
          value:"1",
          label:"event-default",
          status:"Scheduled"
          },
          {
          value:"2",
            label:"event-green",
            status:"Completed"
          },
          {
          value:"3",
            label:"event-orange",
            status:"Postponed"
          },
          {
          value:"4",
            label:"event-red",
            status:"Canceled"
          },
        ],
            leadName:[],
            hubName:[],
            minimumTime: "00:00",
            testtry: ""
        }
    },
    methods: {
        updateStartValue(event) {
            this.startValue = event
        },
        updateEndValue(event) {
            this.endValue = event
        },
        submit(){
            const dateOnly = this.startValue.split("T")[0];
            const enddateOnly = this.endValue.split("T")[0];
            let form = new FormData()
            form.append('lead_id',this.new_meeting.lead_id)
            // form.append('hub_id',this.new_meeting.assigned_to)
            form.append('hub_id',this.leadName[0].hub.hub_id)
            // form.append('minutes_meeting',this.new_meeting.assigned_to)
            form.append('reminder','5')
            form.append('subject',this.new_meeting.title)
            form.append('description',this.new_meeting.description)
            // form.append('remark_meeting','Very Well')
            form.append('start_at',dateOnly)
            form.append('end_at',enddateOnly)
            if(this.new_meeting.time_start){
                form.append('time_start',this.new_meeting.time_start)
            }
            if(this.new_meeting.time_end){
                form.append('time_end',this.new_meeting.time_end)
            }
            form.append('remark_meeting',this.new_meeting.remark_meeting)
            form.append('status',this.new_meeting.status)

            axios.post(services.lead + 'meeting', form, { headers: getHeader() })
                .then(res => {
                    this.notifySuccess('<b>Status: '+res.data.message+'</b> - Successfully Created.')
                    EventBus.$emit('closeModal')
                    EventBus.$emit('refreshCalendar',res.data.data)
                    EventBus.$emit('getnewmeeting',res.data.data)
                    this.resetFormToNull(this.new_meeting)
                })
                .catch(e => {
                    this.errorFunction(e)
                })
        },
        fetchLead(){
            axios.get(services.lead + 'leads', {headers: getHeader()})
            .then(res => {
                this.leadName = res.data.data.data
                this.$emit('listLead',res.data.data)
            })
            .catch(e => {
                this.isTableLoading = false
                this.errorFunction(e)
            })
        },
        fetchHub(){
            axios.get(services.hub + 'hubs', {headers: getHeader()})
                .then(res => {
                    this.hubName = res.data.data
                })
                .catch(e => {
                    this.isTableLoading = false
                    // this.errorFunction(e)
                })
        },
    }
}
</script>